import type { Entity } from '@ms/yammer-data-support';

import type { YammerState } from '../state/types';

export type FindRecordById<T extends Entity> = (state: YammerState, id: Entity['id']) => T | undefined;

type EntityRecordBucketKeys<T extends Entity> = {
  [K in keyof YammerState]: YammerState[K] extends Record<string, T> ? K : never;
}[keyof YammerState];

type CreateFindRecordById = <T extends Entity>(bucket: EntityRecordBucketKeys<T>) => FindRecordById<T>;
export const createFindRecordById: CreateFindRecordById =
  <T extends Entity>(bucket: EntityRecordBucketKeys<T>): FindRecordById<T> =>
  (state, id) => {
    const entity = (state[bucket] as Partial<Record<string, T>>)[id];

    if (!entity) {
      return;
    }

    return entity;
  };

export type FindRecordByIdThrows<T extends Entity> = (state: YammerState, id: Entity['id']) => T;

type CreateFindRecordByIdThrows = <T extends Entity>(bucket: EntityRecordBucketKeys<T>) => FindRecordByIdThrows<T>;
export const createFindRecordByIdThrows: CreateFindRecordByIdThrows =
  <T extends Entity>(bucket: EntityRecordBucketKeys<T>): FindRecordByIdThrows<T> =>
  (state, id) => {
    const entity = (state[bucket] as Partial<Record<string, T>>)[id];
    if (!entity) {
      throw new Error(`Can not find entity '${id}' in bucket [${bucket}]`);
    }

    return entity;
  };
